import { render, staticRenderFns } from "./PlacesList.vue?vue&type=template&id=7e379e0f&"
import script from "./PlacesList.vue?vue&type=script&lang=js&"
export * from "./PlacesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlacesList.vue"
export default component.exports